import DOMPurify from 'dompurify'
import { Marked } from 'marked'

// Single newlines break lines, as they did when messages were shown as plain text.
const marked = new Marked({ gfm: true, breaks: true })

// Following a link in place would leave the meeting, so links open in a new tab.
DOMPurify.addHook('afterSanitizeAttributes', node => {
  if (node instanceof HTMLAnchorElement) {
    node.target = '_blank'
    node.rel = 'noopener noreferrer'
  }
})

/** Renders markdown to a fragment, sanitized since it's written by an agent. */
export function renderMarkdown(text: string): DocumentFragment {
  const html = marked.parse(text, { async: false })
  return DOMPurify.sanitize(html, { RETURN_DOM_FRAGMENT: true })
}
